import {
  HOME_CONST,
  PAGE_CONST,
  PERMISSION_FEATURE,
  PROFILE_CONST,
  SETTINGS_CONST,
} from '../../common/constant/page-constant'
import { HEADER_CONFIG } from '../../common/constant/common-constant'

const initialState = {
  configReducer: {
    config: {
      activeSettingsDetailNavigation: PERMISSION_FEATURE.PHARMACY_STORE,
      isNotificationActive: false,
    },
  },
  alertReducer: {
    alert: {
      addUserAlert: false,
      deleteUserAlert: false,
      addSupplierAlert: false,
      updateSupplierAlert: false,
    },
  },
  loginDataReducer: {
    loginData: {},
  },
  dataReducer: {},
}

export default initialState
